import { Pill } from "@/components/admin/AdminUI";

export default function UserStatus({ user }) {
  return (
    <span className="flex flex-wrap gap-1.5" data-testid="user-status">
      {user.status === "banned" ? <Pill tone="error">Banned</Pill>
        : user.status === "deleted" ? <Pill tone="neutral">Deleted</Pill>
          : <Pill tone="success">Active</Pill>}
      {user.hidden && user.status !== "banned" && <Pill tone="warning">Hidden</Pill>}
    </span>
  );
}
